import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

import ChannelName from './ChannelName';

export default class ChannelListItemName extends Component {
  static propTypes = {
    client: PropTypes.string,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }

  render() {
    const {
      client,
      id,
      name,
    } = this.props;

    return (
      <Link
        className="app-blue no-underline underline-hover f5 fw6"
        to={`/channel/${id}`}
      >
        <ChannelName client={client} name={name} />
      </Link>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ChannelListItemName.jsx
 **/